import { connect } from 'react-redux';

import { State } from 'store/types';
import FirstVisitInfo from './View';


const mapStateToProps = (state: State) => ({
  internationalMode: state.remoteConfig.switches.internationalMode,
});


export default connect(mapStateToProps)(FirstVisitInfo);
